import {
  Button,
  IconButton,
  Stack,
  Typography,
  LinearProgress,
  Box,
  useMediaQuery,
} from "@mui/material"
import React, { useState, useRef, useEffect, useCallback } from "react"
import { useTranslation } from "react-i18next"
import EastIcon from "@mui/icons-material/East"
import WestIcon from "@mui/icons-material/West"
import { nextStyles } from "components/ActivityContent/Activity.GetStarted"
import Image from "components/Image"
import { getStarted, getStartedPng } from "utils/images"
import { styles } from "./GetStartedBuble.styles"
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded"
import secureLocalStorage from "react-secure-storage"
import PauseIcon from "@mui/icons-material/Pause"
import { getStarted as sounds } from "utils/sounds"
import i18n from "i18n"
import { maxWidth600 } from "themes/default/breakpoints"
import { useAuthContext } from "contexts/AuthContext"
import { Howl } from "howler"
import useApi from "modules/getStarted"
import Swal from "sweetalert2"
import withReactContent from "sweetalert2-react-content"
import { theme } from "themes/default/theme"
import { SUPPORTED_LANGUAGES } from "pages/student/activity/common/constants"
import { LOCAL_STORAGE_PREFIX } from "../../common/constants"

export const GET_STARTED_ID = {
  "explanation-activity": "actions_get_started_explanation",
  "explanation-video": "actions_get_started_explanation_video",
  "picture-question": "actions_get_started_picture_and_question",
  "matching-picture": "actions_get_started_matching_pictures",
  "listen-and-choose": "actions_get_started_listen_and_choose",
  "find-the-picture": "actions_get_started_find_the_picture",
  "listen-find-the-picture": "actions_get_started_listen_find_the_picture",
  matching: "actions_get_started_matching",
  "scrambled-sentence": "actions_get_started_scrambled_sentences",
  "soaked-man": "actions_get_started_soacked_man",
  "words-pronounciation": "actions_get_started_words_pronounciation",
  "sentence-pronounciation": "actions_get_started_sentence_pronounciation",
  "reading-outloud": "actions_get_started_reading_outloud",
  interactions: "actions_get_started_interactions",
  "filling-the-blanks": "actions_get_started_filling_the_blanks",
  "filling-the-blanks-write": "actions_get_started_filling_the_blanks_write",
  "picture-and-question-write":
    "actions_get_started_picture_and_question_write",
  dictation: "actions_get_started_dictation",
  "oral-comprehension": "actions_get_started_oral_comprension_long",
  "text-comprehension": "actions_get_started_text_comprehension",
  "written-comprehension": "actions_get_started_written_comprehension",
  "recording-comprehension": "actions_get_started_recording_comprehension",
  "just-write": "actions_get_started_just_write",
  "just-write-multiple": "actions_get_started_just_write_multiple",
  interview: "actions_get_started_interview",
  "interview-2": "actions_activity_graded_by_teacher",
  "just-talk": "actions_get_started_just_talk",
  essay: "actions_get_started_essay",
  "multiple-questions": "actions_get_started_multiple_questions",

  "speech-side-no-mic": "actions_activity_speech",
  "speech-side": "actions_activity_speech",
  "speech-wrong": "actions_activity_speech",
  "speech-settings": "actions_activity_speech",
  "speech-levels": "actions_activity_speech",
  "end-module": "actions_first_module_end",
  "tools-menu": "actions_tools_explanation_overview",
  "tools-menu-2": "actions_second_grammar_module",
  gradeBar: "actions_first_activity_graded",
  retakes: "actions_second_activity_graded",
}

const isTourForced = (force) => {
  if (force) return true
  const queryParams = new URLSearchParams(window.location.search)
  const started = parseInt(queryParams.get("started")) || 0
  return started === 1
}

export const stringify = (obj) => {
  let cache = []
  const str = JSON.stringify(obj, function (key, value) {
    if (typeof value === "object" && value !== null) {
      if (cache.indexOf(value) !== -1) {
        // Circular reference found, discard key
        return
      }
      // Store value in our collection
      cache.push(value)
    }
    return value
  })
  cache = null // reset the cache
  return str
}

export default function GetStartedBuble({
  text = "",
  textComponent = null,
  children,
  onNextClick = () => {},
  onBackClick = () => {},
  onSkipClick = () => {},
  image,
  imagePosition = "left",
  customImageStyle = {},
  showImage = false,
  showNextButton = false,
  showBackButton = false,
  showSkipButton = true,
  showAudio = false,
  audioLink = "",
  customAudioLink,
  checkCss = false,
  allowAutoNext = true,
  audioCallback = () => {},
  forceShow = false,
  textStyles = null,
  imageHeight,
  imagWidth,
}) {
  const { t } = useTranslation()
  const curlang = !SUPPORTED_LANGUAGES.includes(i18n.language?.split("-")[0])
    ? "en"
    : i18n.language?.split("-")[0]
  const [percentage, setPercentage] = useState(0)
  const [isPlaying, setIsPlaying] = useState(false)
  const [autoNextActive, setAutoNextActive] = useState(false)
  const [calcultedImagePosition, setCalculedImagePosition] = useState({})
  const audioRef = useRef()
  const durationRef = useRef(0)
  const matches = useMediaQuery(maxWidth600)
  const { userData, setTourSkiped } = useAuthContext()
  const containerRef = useRef()
  const tNext = useRef()
  const [firstLoad, setFirstLoad] = useState(true)
  const inactivtyTimer = useRef()
  const updateRaf = useRef()
  const autoNextButtonStateRef = useRef(false)
  const soundIdRef = useRef()
  const { setGetStartedViewed, completeAllGetStarted } = useApi()
  const MySwal = withReactContent(Swal)

  const getTutorialNext = () => {
    const value = localStorage.getItem(
      `${LOCAL_STORAGE_PREFIX}TUTORIAL_NEXT_ONENDED_${userData?.userId}`
    )
    try {
      return JSON.parse(value)
    } catch (ex) {
      return value
    }
  }

  const setTutorialNext = (payload) => {
    if (typeof payload !== "string") {
      payload = JSON.stringify(payload)
    }
    localStorage.setItem(
      `${LOCAL_STORAGE_PREFIX}TUTORIAL_NEXT_ONENDED_${userData?.userId}`,
      payload
    )
  }

  useEffect(() => {
    if (percentage >= 100) {
      setIsPlaying(false)
    }
  }, [percentage])

  useEffect(() => {
    autoNextButtonStateRef.current = autoNextActive
  }, [autoNextActive])

  useEffect(() => {
    setFirstLoad(false)
    if (firstLoad) return
    if (!isPlaying) {
      try {
        audioCallback()
      } catch (error) {}
    }
  }, [isPlaying])

  const startCountingInactivity = () => {
    clearTimeout(inactivtyTimer.current)
    inactivtyTimer.current = setTimeout(() => {
      // play audio again
      console.log("play again")
      play()
    }, 8000)
  }

  useEffect(() => {
    return () => {
      clearTimeout(tNext.current)
    }
  }, [autoNextActive, allowAutoNext])

  useEffect(() => {
    setCalculedImagePosition({})
    if (!isTourForced(forceShow)) return
    if (checkCss) {
      setTimeout(() => {
        try {
          const val = document.querySelector(".reactour__popover")
          // print containerRef parent element
          const parent = JSON.parse(
            stringify(containerRef.current.parentElement)
          )
          const firstKey = Object.keys(parent)[1]
          const objStyles = parent[firstKey]?.style
          if (val && firstKey) {
            // const cssText = val.style.cssText
            // element 26 can be --rtp-arrow-top or --rtp-arrow-left
            // element 27 can be --rtp-arrow-left
            const element26 = objStyles["--rtp-arrow-top"]
            const element27 = objStyles["--rtp-arrow-left"]
            const element28 = objStyles["--rtp-arrow-right"]
            // console.warn(element26, element27)
            if (element26 !== undefined && element27 !== undefined) {
              setCalculedImagePosition({ right: 325 })
              return
            }
            if (element26 !== undefined && element28 !== undefined) {
              setCalculedImagePosition({ right: 325, left: undefined })
              return
            }
            if (element27 !== undefined) {
              setCalculedImagePosition({
                right: 325,
                top: -140,
              })
              return
            }
            if (element26 !== undefined) {
              setCalculedImagePosition({
                left: 225,
              })
            }
          }
        } catch (error) {
          console.log("🚀 ~ checkCss ~ error:", error)
        }
      }, 500)
    }
    const isAutoNext = getTutorialNext()
    const value = isAutoNext === null || isAutoNext === true
    setAutoNextActive(value)
    const src = customAudioLink
      ? `${customAudioLink}_${curlang}.mp3`
      : sounds[curlang][audioLink]
    // const src = `${process.env.REACT_APP_TUTORIAL_SOUNDS_URL}/sounds/getStarted/${curlang}/${audioLink}.mp3`
    const audio = new Howl({
      src: [src],
      html5: false,
      onend: (soundId) => {
        // console.log(soundId, soundIdRef.current, "onend")
        cancelAnimationFrame(updateRaf.current)
        clearTimeout(tNext.current)
        setIsPlaying(false)
        if (soundId !== soundIdRef.current) return
        setPercentage(100)
        if (onNextClick && autoNextButtonStateRef.current && allowAutoNext) {
          tNext.current = setTimeout(() => {
            onNextClick()
          }, 1000)
        } else {
          console.log("start counting inactivity")
          startCountingInactivity()
        }
      },
      onplay: (soundId) => {
        clearTimeout(tNext.current)
        if (soundId !== soundIdRef.current) return
        setIsPlaying(true)
        setPercentage(0)
        // Reference
        const onAnimationFrame = () => {
          // If the howl is still playing
          if (audio.playing(soundIdRef.current)) {
            // Calculate the width
            const width =
              (audio.seek(soundIdRef.current) /
                audio.duration(soundIdRef.current)) *
              100
            setPercentage(width)
            // Continue processing updates
            updateRaf.current = requestAnimationFrame(onAnimationFrame)
          } else {
            // Stop processing updates
            cancelAnimationFrame(updateRaf.current)
          }
        }
        // Start processing updates
        updateRaf.current = requestAnimationFrame(onAnimationFrame)
      },
      onstop: () => {
        setIsPlaying(false)
        cancelAnimationFrame(updateRaf.current)
      },
    })
    setPercentage(0)
    setIsPlaying(false)
    audioRef.current = audio
    // get audio duration
    const duration = audio._duration * 1000
    durationRef.current = duration
    const idRef = audio.play()
    soundIdRef.current = idRef
    setIsPlaying(true)
    return () => {
      setIsPlaying(false)
      setPercentage(0)
      clearTimeout(tNext.current)
      clearTimeout(inactivtyTimer.current)
      try {
        audioRef?.current?.pause(idRef)
        cancelAnimationFrame(updateRaf.current)
      } catch (error) {}
    }
  }, [audioLink, customAudioLink, allowAutoNext])

  const play = () => {
    const audio = audioRef.current
    audio.volume = 0.5

    if (!isPlaying) {
      clearTimeout(inactivtyTimer.current)
      setIsPlaying(true)
      audio.play(soundIdRef.current)
    }

    if (isPlaying) {
      setIsPlaying(false)
      audio.pause(soundIdRef.current)
    }
  }

  const onSkipTutorial = useCallback(() => {
    setTourSkiped(true)
    onSkipClick()
    const currentTutorial = secureLocalStorage.getItem(
      `current-tour_${userData?.userId}`
    )
    if (currentTutorial) {
      setGetStartedViewed(GET_STARTED_ID[currentTutorial])
      // get current count
      const count = localStorage.getItem(
        `${LOCAL_STORAGE_PREFIX}TUTORIAL_SKIPPED_TIMES_${userData?.userId}`
      )
      // set new count
      localStorage.setItem(
        `${LOCAL_STORAGE_PREFIX}TUTORIAL_SKIPPED_TIMES_${userData?.userId}`,
        parseInt(count || 0) + 1
      )
      const skipAnnouncementValue = localStorage.getItem(
        `${LOCAL_STORAGE_PREFIX}TUTORIAL_SKIP_ANNOUNCEMENT_${userData?.userId}`
      )
      if (count > 0 && count % 2 === 0 && skipAnnouncementValue !== "true") {
        MySwal.fire({
          html: (
            <Stack
              sx={{
                fontSize: "1.2rem",
                color: "inherit",
              }}
            >
              <Stack
                sx={{ textAlign: "center", padding: "15px" }}
                alignItems={"center"}
              >
                <Image
                  src={`${window.location.origin}/source/ui/suggestionBox/image/idea.png`}
                  width={128}
                  height={128}
                />
              </Stack>
              {t("Would you like to stop all the tutorials?")}
              <br />
              {t(
                "You can always activate the tutorial again by clicking on help."
              )}
            </Stack>
          ),
          confirmButtonColor: theme.palette.info.button,
          confirmButtonText: t("accept"),
          showCancelButton: true,
          cancelButtonText: t("cancel"),
          cancelButtonColor: theme.palette.cancel.main,
          customClass: {
            htmlContainer: "custom-swal2-html-container",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            completeAllGetStarted()
            localStorage.setItem(
              `${LOCAL_STORAGE_PREFIX}TUTORIAL_SKIP_ANNOUNCEMENT_${userData?.userId}`,
              true
            )
          }
        })
      }
    }
  }, [])

  if (children) {
    return children
  }

  return (
    <Stack ref={containerRef}>
      <Stack direction={"row"} position={"relative"}>
        {showImage && isTourForced(forceShow) && !matches && (
          <Image
            key={
              isPlaying
                ? getStarted[curlang][image] || getStarted[curlang][11]
                : getStartedPng[curlang][image] || getStartedPng[curlang][11]
            }
            src={
              isPlaying
                ? getStarted[curlang][image] || getStarted[curlang][11]
                : getStartedPng[curlang][image] || getStartedPng[curlang][11]
            }
            width={imagWidth || 200}
            height={imageHeight || 300}
            style={{
              height: "auto",
              width: imagWidth || 300,
              maxHeight: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "transparent",
            }}
            wrapperStyle={{
              maxWidth: 400,
              position: "absolute",
              top: -30,
              ...(imagePosition === "left" && { right: 325 }),
              ...(imagePosition === "right" && { left: 225 }),
              ...calcultedImagePosition,
              ...customImageStyle,
            }}
          />
        )}
        {textComponent || (
          <Typography fontSize={15} sx={textStyles}>
            {t(text)}
          </Typography>
        )}
      </Stack>
      {(showAudio || audioLink?.length > 0 || customAudioLink?.length > 0) &&
        isTourForced(forceShow) && (
          <Stack
            sx={styles.mediaContainer}
            flexDirection={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <IconButton
              size="small"
              sx={styles.playButton}
              onClick={play}
              className="tour-popover-play-btn"
            >
              {isPlaying ? (
                <PauseIcon sx={styles.playIcon} />
              ) : (
                <PlayArrowRoundedIcon sx={styles.playIcon} />
              )}
            </IconButton>
            <Box sx={styles.sliderContainer}>
              <LinearProgress
                variant="determinate"
                value={percentage}
                sx={styles.slider}
              />
            </Box>
            <IconButton
              size="small"
              sx={styles.redoIButton}
              onClick={() => {
                setTutorialNext(!autoNextActive)
                setAutoNextActive(!autoNextActive)
              }}
              disableRipple
            >
              <Typography color={autoNextActive ? "primary" : "gray"}>
                {t("Auto")}
              </Typography>
            </IconButton>
          </Stack>
        )}
      {!isTourForced() && showSkipButton && (
        <Stack>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            sx={{ ...nextStyles, ...styles.seeLaterBtn }}
            className="tour-popover-see-later-btn"
            onClick={() => {
              onSkipTutorial()
            }}
          >
            <Typography sx={styles.seeLaterBtnText}>
              {t("See tutorial later")}
            </Typography>
          </Button>
        </Stack>
      )}
      {(showNextButton || showBackButton) && (
        <Stack spacing={0.5} direction={"row"} sx={styles.buttonsContainer}>
          {showBackButton && (
            <Button
              variant="contained"
              color="primary"
              disableElevation
              sx={nextStyles}
              className="tour-popover-back-btn"
              onClick={() => {
                clearTimeout(tNext.current)
                onBackClick()
              }}
            >
              <WestIcon />
            </Button>
          )}
          {showNextButton && (
            <Button
              variant="contained"
              color="primary"
              disableElevation
              sx={nextStyles}
              onClick={() => {
                clearTimeout(tNext.current)
                onNextClick()
              }}
              className="tour-popover-next-btn"
            >
              <EastIcon />
            </Button>
          )}
        </Stack>
      )}
    </Stack>
  )
}
